import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { ConfirmDialogModule, CalendarModule, FileUploadModule, DialogModule, InputMaskModule, DataTableModule } from 'primeng/primeng';

import { SispacSharedModule } from '../shared/sispac-shared.module';

import { Ng2BRPipesModule } from 'ng2-brpipes';
import { CurrencyMaskModule } from 'ng2-currency-mask';

import { PropostaRouting } from './proposta.routing';



import { LgpdService } from "../../services/lgpd.service";
import { HistoricoEmailComponent } from './historicoEmail/historico-email.component';
import { HistoricoAlteracaoComponent } from './historicoAlteracao/historico-alteracao.component';
import { HistoricoGeralService } from '../../services/historico-geral.service';

@NgModule({
    declarations: [
        HistoricoEmailComponent, HistoricoAlteracaoComponent
    ],
    imports: [
        BrowserModule,
        FormsModule, ReactiveFormsModule,

        PropostaRouting,

        ConfirmDialogModule, CalendarModule, FileUploadModule, DialogModule, InputMaskModule, DataTableModule,

        Ng2BRPipesModule,
        CurrencyMaskModule,

        SispacSharedModule
    ],
    providers: [ LgpdService, HistoricoGeralService ],
})
export class PropostaModule { }



// WEBPACK FOOTER //
// ./src/app/components/proposta/proposta.module.ts